var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHeadsetFolded = function SvgIconHeadsetFolded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.846 15.801 3 16.75v-1a9 9 0 1 1 18 0v1l-2.846-.949m-10.056.351a1.38 1.38 0 0 1-.97.405 1.36 1.36 0 0 1-.967-.397 2.76 2.76 0 0 1 0-3.904l.965-.964a2.062 2.062 0 0 1 2.916 2.916zm7.783-.021c.256.256.603.4.963.402.361.001.707-.14.961-.395a2.74 2.74 0 0 0 0-3.878l-.958-.959a2.05 2.05 0 0 0-2.898 2.898z"
  })));
};
export default SvgIconHeadsetFolded;